<!-- Copyright The Linux Foundation and each contributor to LFX. -->
<!-- SPDX-License-Identifier: MIT -->
<div class="px-5 py-4 border-bottom border-gray bg-lighter">
    <div class="content-wrapper">
        <button
            class="btn btn-link text-info d-flex align-items-center justify-content-center p-0 mb-2 font-weight-normal"
            [routerLink]="'../../../'" i18n>
            <i class="ni ni-bold-left mr-1"></i> Back
        </button>
        <div class="d-flex justify-content-between">
            <h2 class="display-2" i18n>Manage User Scope</h2>
        </div>
    </div>
</div>

<div class="p-5 mb-4 border-bottom flex-1">
    <div class="content-wrapper">

        <app-user-detail-card [user]="_selectedUser" [role]="role$ | async">
        </app-user-detail-card>

        <div class="mt-5"></div>

        <app-role-scope-card [orgId]="organizationId" [roleDetail]="roleDetail$ | async" [user]="_selectedUser">
        </app-role-scope-card>

        <div *ngIf="!addUserScopeMode">
            <div class="mt-5"></div>
            <button class="btn col-2 btn-info" (click)="addUserScope()" i18n>Add User Scope</button>
        </div>

        <ng-container *ngIf="addUserScopeMode">
            <div class="px-5">
                <app-role-scope-options 
                [roleId]="roleId" 
                [usernames]="[_selectedUser.username]"
                (saved)="useProjectCommitteeHandler = false; addUserScopeMode = false"
                (optionSelected)="onOptionSelected($event)"
                (validityChange)="updateValidity($event)">
                </app-role-scope-options>
                <div class="mt-5"></div>
            </div>

            <div *ngIf="!useProjectCommitteeHandler" class="d-flex justify-content-end border-top border-gray px-5 py-3">
                <button class="mr-auto btn btn-link-default" (click)="cancel()" i18n>Cancel
                </button>
                <button class="btn btn-info btn-size-normal" [disabled]="!isValid" (click)="submit()" i18n>
                    Update User Scope
                </button>
            </div>
        </ng-container>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/access-management/organizations/organization-role-manage-user-scopes/organization-role-manage-user-scopes.component.html